/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-04-20 14:09:52
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */

export default{
    data() {
        return {
        }
    },
    props:{
        imageSize: {
            type: Number || String,
            default: 140
        },
        text: {
            type: String,
            default: '空空如也~'
        },
        image: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '196px'
        },
        height: {
            type: String,
            default: '121px'
        },
        name: {
            type: String,
            default: 'search'
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
    },
    computed: {
        getUrl() {
            var image = this.image
            var name = this.name
            var _url = ""
            if(image) {
                _url = image
            }
            switch(name) {
                case 'content': 
                    _url = require("@/assets/images/empty/content.png")
                break;
                case 'search': 
                    _url = require("@/assets/images/empty/search.png")
                break;
                case 'collection': 
                    _url = require("@/assets/images/empty/collection.png")
                break;
                case 'success': 
                    _url = require("@/assets/images/v2/pop_icon01.jpg")
                break;
                default: 
                    _url = require("@/assets/images/empty/content.png")
                break;
            }
            return _url
        }
    }
}